export const DefaultHomeCurrency = 'USD';